// 推广城市
export const PROMOTION_CITIES = [ 
  '0755', // 深圳
  '020',  // 广州
  '0551', // 合肥
]

// 默认城市
export const DEFAULT_CITY = {
  center: [114.085947, 22.547],
  citycode: '0755',
  city: '深圳市',
  adcode: '440300',
}